import { SafeHtml } from "./SafeHtml.tsx";
import { translateEventText } from "../util/eventText.ts";
import i18n from "../util/i18n.ts";
import type { InformationNews } from "./informationFeed.ts";

export const InformationNewsDetail = ({
  news,
  sourceLabel,
  title,
}: {
  news: InformationNews;
  sourceLabel: string;
  title: string;
}) => (
  <article>
    <div className="d-flex align-items-center gap-2 mb-3">
      <span className="badge text-bg-secondary">{title}</span>
      <span className="small text-body-secondary">
        {i18n.t("information.newsMeta", {
          ns: "ui",
          defaultValue: "{{source}} · {{season}}",
          season: news.season,
          source: sourceLabel,
        })}
      </span>
    </div>
    <div data-information-center-news-text="">
      <SafeHtml dirty={translateEventText(news)} />
    </div>
  </article>
);

export default InformationNewsDetail;
